// utils/navigator.js
import router from '@/router'
import store from '@/store'

// 封装导航方法
const navigator = {
	// 跳转（push）
	go(path = '/pc/home', query = {}, params = {}) {
		if (params && Object.keys(params).length > 0) {
			// 推荐 name + params
			router.push({
				name: path,
				params
			})
		} else {
			router.push({
				path,
				query
			})
		}
	},
	//跳转登录页面
	goLogin() {
		let isMobile = store?.state.isMobile || localStorage.getItem('isMobile') === "true"
		// console.log(isMobile)
		let url = '/pc/login'
		if (isMobile == 'true') {
			url = '/mobile/login'
		}
		this.go(url)
	},
	// 替换（replace）
	replace(path = '/pc/home', query = {}, params = {}) {
		if (params && Object.keys(params).length > 0) {
			router.replace({
				name: path,
				params
			})
		} else {
			router.replace({
				path,
				query
			})
		}
	},

	// 后退
	back(step = -1) {
		router.go(step)
	}
}

export default navigator